import {
    config,
} from './utils';

const getEventos = () => {
    return fetch(config.apiUrl + '/api/evento/get-eventos', {
        credentials: 'include',
        mode: 'cors',
    }).then(response => response.json());
};

export {
    getEventos,
};